var Marquee = require('./marquee');
var Chain = require('./chain');
var Takeover = require('./takeover');

// Initialize Components
new Marquee({
	el: '.marquee p',
	movementRange: 4,
	orientationRange: 20
});
new Chain({
	el: '#chain-path',
	minimumLinkDistance: 3
});
new Takeover({
	el: 'body',
	open: '.open button',
	close: '.close'
});


// WEBPACK FOOTER //
// ./src/app.js